import React, { useEffect, useRef, useContext, useState } from "react";
import "./TelephoneSearch.scss";
import { GetClaimByPhoneNumber } from "../../../helpers/Api";
// import { TextInput } from "ebs-component-library";
import { InputText } from 'primereact/inputtext';
import { AppContext } from "../../../context/AppContext";

const TelephoneSearch = () => {
  const [claimsByPhoneNumber, getClaimsByPhoneNumber] = GetClaimByPhoneNumber();
  const [salesForceId, setSalesForceId] = useState("123456789123456789");
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [makeRequest, setMakeRequest] = useState(false);

  const url = new URLSearchParams(window.location.search);
  const { phoneSearchDispatch, translations } = useContext(AppContext);
  const searchButtonRef = useRef(null);

  useEffect(() => {
    const phoneNumberUrl = url.get("phoneNumber");
    const salesForceUrlId = url.get("SalesforceID");
    if(salesForceUrlId) {
      setSalesForceId(salesForceUrlId);
      setMakeRequest(true);
    }
    
    if(phoneNumberUrl) {
      console.log("Salesforce number from URL", salesForceUrlId);
      setPhoneNumber(phoneNumberUrl);
      setMakeRequest(true);
    }
  }, [url]);

  useEffect(() => {
    const routeTo = claimsByPhoneNumber.data
      ? claimsByPhoneNumber.data.length > 1
        ? "/"
        : claimsByPhoneNumber.data.length === 1
        ? "/" + claimsByPhoneNumber.data[0].id + "/" + salesForceId
        : "/"
      : "";

    phoneSearchDispatch({
      type: "update",
      value: claimsByPhoneNumber,
      routeTo: routeTo
    });
  }, [claimsByPhoneNumber, phoneSearchDispatch]);

  const enterKeyHandler = e => {
    if (e.keyCode === 13) {
      if (searchButtonRef.current) {
        searchButtonRef.current.click();
      }
    }
  };

  const handleSearchClick = (e) => {
    getClaimsByPhoneNumber(phoneNumber, salesForceId); // Fake input because tmnf do not use frontend. They only use API
  };

  const handleInputChange = (e) => {
    setPhoneNumber(e.target.value);
  }

  useEffect(() => {
    if (phoneNumber && salesForceId) {
      getClaimsByPhoneNumber(phoneNumber, salesForceId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [makeRequest]);

  useEffect(() => {
    window.addEventListener("keydown", enterKeyHandler);
    return () => {
      window.removeEventListener("keydown", enterKeyHandler);
    };
  }, []);

  return (
    <div className="telephone-search-container">
      <InputText
        onChange={handleInputChange}
        placeholder={translations.phoneSearchBar.hint}
        value={phoneNumber? phoneNumber :  ""}
        className="telephone-input"
      /> &nbsp;&nbsp;
      <button
        ref={searchButtonRef}
        onClick={handleSearchClick}
        className="search-button"
        data-testid="search-button"
        type="button"
      >
        <span className="magnifying-glass" />
      </button>
    </div>
  );
};

export default TelephoneSearch;
